"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _vuex = require("vuex");
var _monitoringConfig = require("@/api/priceSetting/priceMonitoring/monitoringConfig.js");
var _options = require("@/utils/options.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SpecificProductRulesForm',
  components: {
    merchantName: _merchantName.default
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['merPlatProductClassify'])),
  data: function data() {
    return {
      dialogVisible: false,
      // 是否显示弹框
      dialogTitle: '',
      // 弹框标题
      formType: '',
      // 表单类型：create - 新增 update - 修改
      formLoading: false,
      //  表单加载状态
      step: 1,
      // 步骤  1 - 选择商品 2 - 填写商品监控规则
      tableData: {
        // 列表数据
        data: [],
        total: 0
      },
      listLoading: false,
      // 列表加载状态
      tableFrom: {
        page: 1,
        limit: 10,
        keywords: null,
        // 查询商品关键字
        categoryId: null,
        // 商品分类id
        brandName: null,
        // 商品品牌
        merId: null // 商户id
      },
      selectedProducts: [],
      // 选中商品数组
      categoryProps: {
        // 商品分类属性
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      monitorRateIdOptions: _options.monitorRateIdOptions,
      // 监控频率
      platformIdsOptions: _options.platformIdsOptions,
      // 对比平台
      specialRuleIdsOptions: _options.specialRuleIdsOptions,
      // 特殊监控规则
      rulesForm: {
        // 表单数据
        id: null,
        productSkuItems: [],
        // 商品id和规格id
        monitorRateId: null,
        // 监控频率
        platformIds: [],
        // 对比平台
        raiseWarnRatio: null,
        // 上涨预警阈值(比例)
        decreaseWarnRatio: null,
        // 下降预警阈值(比例)
        raiseWarnFix: null,
        // 上涨预警阈值(固定值)
        decreaseWarnFix: null,
        // 下降预警阈值(固定值)
        specialRuleIds: [] // 特殊监控规则
      },
      rules: {
        monitorRateId: [{
          required: true,
          message: '请选择监控频率',
          trigger: ['change', 'blur']
        }],
        platformIds: [{
          required: true,
          message: '请选择对比平台',
          trigger: ['change', 'blur']
        }]
      }
    };
  },
  methods: {
    // 获取行唯一标识
    getRowKey: function getRowKey(row) {
      return "".concat(row.id, "-").concat(row.skuId);
    },
    // 打开弹框
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type, id) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.dialogVisible = true;
              this.formType = type;
              this.getList();
              if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
              if (!(type === 'create')) {
                _context.n = 1;
                break;
              }
              this.dialogTitle = '添加监控商品';
              this.step = 1;
              _context.n = 5;
              break;
            case 1:
              this.dialogTitle = '修改商品监控规则';
              this.step = 2;
              this.formLoading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _monitoringConfig.getMonitorRuleDetailApi)(id);
            case 3:
              this.rulesForm = _context.v;
            case 4:
              _context.p = 4;
              this.formLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[2,, 4, 5]]);
      }));
      function open(_x, _x2) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    // 筛选查询
    handleSearchList: function handleSearchList() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 重置查询表单
    resetSearchForm: function resetSearchForm() {
      this.$refs.queryFormRef.resetFields();
      this.tableFrom.page = 1;
      this.getList();
    },
    // 获取列表
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this = this;
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.listLoading = true;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _monitoringConfig.getProductSelectListApi)(this.tableFrom);
            case 2:
              res = _context2.v;
              this.tableData.data = res.list || [];
              this.tableData.total = res.total;

              // 恢复当前页面的选中状态
              this.$nextTick(function () {
                _this.restoreSelection();
              });
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.log('获取列表失败：', _t);
            case 4:
              _context2.p = 4;
              this.listLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 恢复当前页面的选中状态
    restoreSelection: function restoreSelection() {
      var _this2 = this;
      if (this.tableData.data && this.tableData.data.length > 0) {
        this.tableData.data.forEach(function (row) {
          var isSelected = _this2.selectedProducts.some(function (product) {
            return product.productId === row.id && product.skuId === row.skuId;
          });
          if (isSelected) {
            _this2.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      }
    },
    // 处理单个选择
    handleSelect: function handleSelect(selection, row) {
      var _this3 = this;
      var isSelected = selection.some(function (item) {
        return _this3.getRowKey(item) === _this3.getRowKey(row);
      });
      if (isSelected) {
        // 添加到选中状态
        var exists = this.selectedProducts.some(function (product) {
          return product.productId === row.id && product.skuId === row.skuId;
        });
        if (!exists) {
          this.selectedProducts.push({
            productId: row.id,
            skuId: row.skuId
          });
        }
      } else {
        // 从选中状态移除
        var index = this.selectedProducts.findIndex(function (product) {
          return product.productId === row.id && product.skuId === row.skuId;
        });
        if (index > -1) {
          this.selectedProducts.splice(index, 1);
        }
      }
    },
    // 处理全选
    handleSelectAllChange: function handleSelectAllChange(selection) {
      var _this4 = this;
      if (selection.length > 0) {
        // 全选 - 添加当前页所有未选中的商品
        selection.forEach(function (row) {
          var exists = _this4.selectedProducts.some(function (product) {
            return product.productId === row.id && product.skuId === row.skuId;
          });
          if (!exists) {
            _this4.selectedProducts.push({
              productId: row.id,
              skuId: row.skuId
            });
          }
        });
      } else {
        // 取消全选 - 移除当前页的所有商品
        this.tableData.data.forEach(function (row) {
          var index = _this4.selectedProducts.findIndex(function (product) {
            return product.productId === row.id && product.skuId === row.skuId;
          });
          if (index > -1) {
            _this4.selectedProducts.splice(index, 1);
          }
        });
      }
    },
    // 下一步
    nextStep: function nextStep() {
      if (!this.selectedProducts.length) {
        this.$message.error('请选择要监控的商品！');
        return;
      }
      this.rulesForm.productSkuItems = this.selectedProducts;
      this.step = 2;
    },
    // 翻页
    pageChange: function () {
      var _pageChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(page) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.tableFrom.page = page;
              _context3.n = 1;
              return this.getList();
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function pageChange(_x3) {
        return _pageChange.apply(this, arguments);
      }
      return pageChange;
    }(),
    // 每页条数改变
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 获取商户ID
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
    },
    // 提交表单
    submitForm: (0, _validate.Debounce)(function () {
      var _this5 = this;
      // 校验表单
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(valid) {
          var valids, hasValidValue;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (valid) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                // 检查阈值要求
                valids = [_this5.rulesForm.raiseWarnRatio, _this5.rulesForm.decreaseWarnRatio, _this5.rulesForm.raiseWarnFix, _this5.rulesForm.decreaseWarnFix];
                hasValidValue = valids.some(function (val) {
                  return val !== null && val !== undefined && val !== '';
                });
                if (hasValidValue) {
                  _context4.n = 2;
                  break;
                }
                _this5.$message.error('预警阈值需至少设置一个值！');
                return _context4.a(2);
              case 2:
                // 提交请求
                _this5.formLoading = true;
                _context4.p = 3;
                _context4.n = 4;
                return (0, _monitoringConfig.savePriceMonitorRuleApi)(_this5.rulesForm);
              case 4:
                _this5.$message.success("".concat(_this5.formType === 'create' ? '添加' : '修改', "\u6210\u529F\uFF01"));
                _this5.dialogVisible = false;
                _this5.$emit('success');
              case 5:
                _context4.p = 5;
                _this5.formLoading = false;
                return _context4.f(5);
              case 6:
                return _context4.a(2);
            }
          }, _callee4, null, [[3,, 5, 6]]);
        }));
        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }),
    // 重置表单
    resetForm: function resetForm() {
      this.$refs.queryFormRef.resetFields();
      this.tableFrom.page = 1;
      this.tableData = {
        data: [],
        total: 0
      };
      this.selectedProducts = [];
      this.rulesForm = {
        id: null,
        productSkuItems: [],
        // 商品id
        monitorRateId: null,
        // 监控频率
        platformIds: [],
        // 对比平台
        raiseWarnRatio: null,
        // 上涨预警阈值(比例)
        decreaseWarnRatio: null,
        // 下降预警阈值(比例)
        raiseWarnFix: null,
        // 上涨预警阈值(固定值)
        decreaseWarnFix: null,
        // 下降预警阈值(固定值)
        specialRuleIds: [] // 特殊监控规则
      };
      this.$refs.formRef.resetFields();
      this.formLoading = false;
    }
  }
};